import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import './dnd.css';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {

  const handleClickOpen = () => {
    props.setOpen(true);
  };
  const handleClose = () => {
    props.setOpen(false);
       
  };
  
  const handleClick = () =>{
    // if (props.handleData != null){
    //   props.handleData(props.data)
    // }
    props.handleLoad()
  }

  return (
    <div>
      <Dialog  onClose={handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
        <DialogTitle className='dialogHeader' id="customized-dialog-title" onClose={handleClose} >
          {props.title}
        </DialogTitle>
        <DialogContent >
          <Typography gutterBottom>
            {props.message}
          </Typography>
          <select id={props.inp} className='select'>
            {props.render()}
            </select>
  


        </DialogContent>
        <DialogActions >
          {/* <Button autoFocus onClick={props.handleLoad} color="primary"> */}
          <Button autoFocus onClick={handleClick} color="primary">
            SELECT
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
